import { FC } from 'react';
import { Stack } from '@mui/material';
import {
  Loader,
  NothingFoundAlert,
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useTranslation } from 'react-i18next';
import { useRouteParams } from 'utils/useIdParam';
import { useNewsCategory } from 'store/news';
import { CategoryActions, NewsDisabledFeatureAlert } from 'containers/news';
import { useRouteMatch } from 'react-router-dom';

export const NewsCategoryDetailsLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { id: categoryId } = useRouteParams(ROUTES.news.categories.details);

  const { data: category, isLoading } = useNewsCategory(categoryId);

  if (categoryId && isLoading) return <Loader />;
  if (categoryId && !category) return <NothingFoundAlert />;

  return (
    <Stack gap={2}>
      <NewsDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('permissions.newsModule'),
            url: ROUTES.news.list,
          },
          {
            label: t('news.topics.label'),
            url: `${ROUTES.news.list}?tab=categories`,
          },
          {
            label: !categoryId
              ? t('custom_employee_category.create_category')
              : category
              ? category.name
              : '',
          },
        ]}
        side={
          category ? (
            <CategoryActions id={category.id} name={category.name} />
          ) : null
        }
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'settings',
                label: t('common.settings'),
                url: categoryId
                  ? ROUTES.news.categories.details.replace(':id', categoryId)
                  : ROUTES.news.categories.create,
                isActive:
                  path === ROUTES.news.categories.details ||
                  path === ROUTES.news.categories.create,
                disabled: !category,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
